<template>
  <div class="subscribe-container">
    <div class="subscribe-content">
      <header>
        <router-link
          class="go-back"
          to="/"
        >
          <span>←</span>Back
        </router-link>
      </header>
      <h1>
        Subscribe to the awesome 📩
      </h1>
      <p>
        New palettes and products are coming soon!
        <br>
        <br> Get in the list to be the first to know when we launch new palettes and products.
        <br><br>We will only email you when we got something new.
        <br>
      </p>
      <div class="email-area">
        <label for="">Your Email:</label>
        <div
          class="input-container"
          :class="{error: emailError}"
        >
          <span class="error-message">{{emailError}}</span>
          <input
            type="text"
            v-model.trim="email"
            autofocus
            @keyup.enter="submit"
          >
        </div>
      </div>
      <br>
      <div
        class="beta-testing"
        style="display:none"
        @click="betaTesting = !betaTesting; playSound(betaTesting);"
      >
        <div
          class="checkbox"
          :class="{checked: betaTesting}"
        ></div>
        <span>I also want to join to the beta testing group.</span>
      </div>
      <div
        class="twitter-handle"
        v-show="betaTesting"
      >
        <label for="">Your Twitter username:</label>
        <div
          class="input-container"
          :class="{error: twitterError}"
        >
          <span class="error-message">Required</span>
          <input
            type="text"
            v-model.trim="twitter"
            @keyup.enter="submit"
          >
        </div>
      </div>
      <div
        class="interests"
        v-show="betaTesting"
      >
        <label for="">Your interests:</label>
        <div
          class="option"
          @click="interests.crypto = !interests.crypto; playSound(interests.crypto);"
        >
          <div
            class="checkbox"
            :class="{checked: interests.crypto}"
          ></div>
          <span>Crypto Currencies</span>
        </div>
        <div
          class="option"
          @click="interests.entrpreneurship = !interests.entrpreneurship; playSound(interests.entrpreneurship);"
        >
          <div
            class="checkbox"
            :class="{checked: interests.entrpreneurship}"
          ></div>
          <span>Entrepreneurship</span>
        </div>
        <div
          class="option"
          @click="interests.design = !interests.design; playSound(interests.design);"
        >
          <div
            class="checkbox"
            :class="{checked: interests.design}"
          ></div>
          <span>Design</span>
        </div>
        <div
          class="option"
          @click="interests.development = !interests.development; playSound(interests.development);"
        >
          <div
            class="checkbox"
            :class="{checked: interests.development}"
          ></div>
          <span>Development</span>
        </div>
        <div
          class="option"
          @click="interests.productivity = !interests.productivity; playSound(interests.productivity);"
        >
          <div
            class="checkbox"
            :class="{checked: interests.productivity}"
          ></div>
          <span>Productivity</span>
        </div>
      </div>
      <div
        class="bottom"
        :class="{'beta-testing-active': betaTesting}"
      >
        <a
          class="button"
          @click="submit"
          href="javascript:;"
        >
          Submit
        </a>
        <div
          class="status"
          v-show="status.trim() != ''"
        >
          <vue-typer
            caret-animation='blink'
            :text=status
            :repeat='1'
            :type-delay='30'
            :pre-erase-delay='20000000'
          ></vue-typer>
        </div>
      </div>
      <transition
        name="fadeHeight"
        mode="out-in"
      >
        <header
          class="bottom"
          v-show="success"
        >
          <router-link
            class="go-back"
            to="/"
          >
            <span>←</span> Go back to palettes page
          </router-link>
        </header>
      </transition>
    </div>
    <Footer />
  </div>
</template>

<script>
import request from "request-promise";
import { VueTyper } from "vue-typer";
import Footer from "@/components/Footer";

export default {
  name: "Subscribe",
  components: {
    VueTyper,
    Footer
  },
  data() {
    return {
      email: "",
      twitter: "",
      emailError: "",
      twitterError: false,
      betaTesting: false,
      status: " ",
      success: false,
      interests: {
        crypto: false,
        entrpreneurship: false,
        design: false,
        development: false,
        productivity: false
      }
    };
  },
  metaInfo: {
    title: "Subscribe"
  },
  beforeMount() {
    $crisp.push(["do", "chat:show"]);
  },
  methods: {
    submit: function() {
      this.emailError = "";
      this.twitterError = false;
      if (this.email === "") {
        this.emailError = "Please enter a valid email address";
        this.success = false;
      }
      if (this.betaTesting && this.twitter === "") {
        this.twitterError = true;
        this.success = false;
      }
      if (this.emailError || this.twitterError) return;
      this.status = "☝️ Just a second ...";
      //Post
      request
        .post({
          uri: "https://asteya.network/host/mc.php",
          form: {
            email: this.email,
            site: "fuic"
          }

          // twitter: this.twitter,
          // crypto: this.interests.crypto,
          // entrpreneurship: this.interests.entrpreneurship,
          // design: this.interests.design,
          // development: this.interests.development,
          // productivity: this.interests.productivity
        })
        .then(res => {
          // console.log(res.data);
          setTimeout(() => {
            if (res !== "1") {
              this.emailError = res;
              this.status = "⛔️  " + res;
              this.success = false;
            } else {
              this.status = "✅  Thank you, you're successfully subscribed 🙏";
              setTimeout(() => {
                this.success = true;
              }, 1500);
            }
          }, 1500);
        });
    },
    playSound(bool) {
      if (bool) {
        window.sounds.sound2.currentTime = 0;
        window.sounds.sound2.play();
      } else {
        window.sounds.sound1.currentTime = 0;
        window.sounds.sound1.play();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/styles/common.scss";
.subscribe-container {
  @include sub-container();
  .subscribe-content {
    @include sub-content();
  }
  header {
    @include sub-header();
    &.bottom {
      margin-top: 50px;
    }
  }
  .input-container {
    width: auto;
    border: 3px solid #fff;
    width: 500px;
    height: 58px;
    margin-top: 16px;
    float: left;
    border-radius: 4px;
    background: #fff;
    position: relative;
    transition: all 0.2s;
    .error-message {
      background: #ff6969;
      color: #fff;
      font-size: 14px;
      position: absolute;
      right: 0px;
      top: 0px;
      letter-spacing: 0px;
      border-bottom-left-radius: 4px;
      transform: scale(0);
      transition: all 0.2s;
      transform-origin: 100% 0%;
      letter-spacing: 0.3px;
      padding: 0px;
    }
    &.error {
      border-color: #ff6969;
      .error-message {
        transform: scale(1);
        padding: 2px 8px 4px 8px;
      }
    }
  }
  input {
    width: 100%;
    height: 100%;
    line-height: 18px;
    border-radius: 4px;
    background: #fff;
    font-family: "Barlow";
    font-size: 18px;
    font-weight: 600;
    padding: 12px 16px;
    box-sizing: border-box;
    border: none;
    float: left;
    display: inline-block;
  }
  .email-area {
    width: 100%;
    margin-top: 20px;
    float: left;
  }
  .beta-testing {
    float: left;
    width: 100%;
    margin-top: 30px;
    cursor: pointer;
    span {
      height: 20px;
      line-height: 20px;
      display: inline-block;
      margin-left: 13px;
      user-select: none;
      width: 90%;
      height: calc(100% - 13px);
    }
  }
  .checkbox {
    width: 20px;
    height: 20px;
    border: 2px solid #fff;
    border-radius: 4px;
    float: left;
    position: relative;
    &:before {
      content: "";
      background: #fff;
      width: 12px;
      height: 12px;
      transform: scale(0);
      border-radius: 2px;
      position: absolute;
      left: 4px;
      top: 4px;
      transition: all 0.2s;
      transform-origin: 50% 50%;
    }
    &.checked:before {
      transform: scale(1);
    }
  }
  label {
    float: left;
    display: inline-block;
    width: 100%;
    font-size: 18px;
    letter-spacing: 1.2px;
    margin-top: 20px;
  }
  .twitter-handle {
    float: left;
    width: 100%;
    clear: both;
    .input-container {
      width: 250px;
    }
  }
  .interests {
    float: left;
    width: 100%;
    clear: both;
    .option {
      margin-top: 10px;
      margin-right: 40px;
      height: 40px;
      float: left;
      line-height: 40px;
      cursor: pointer;
      user-select: none;
      span {
        font-size: 17px;
        height: 40px;
        line-height: 40px;
        position: relative;
        top: -1px;
      }
      .checkbox {
        margin-top: 8px;
        margin-right: 13px;
      }
    }
  }
  .bottom {
    float: left;
    .status {
      display: inline-block;
      float: left;
      margin-top: 63px;
      margin-left: 30px;
    }
    .button {
      display: inline-block;
      float: left;
      clear: both;
      &.beta-testing-active {
        top: -20px;
        position: relative;
      }
    }
  }
}

@include sub-mobile();

.fadeHeight-enter-active,
.fadeHeight-leave-active {
  transition: all 0.8s;
  max-height: 230px;
}
.fadeHeight-enter,
.fadeHeight-leave-to {
  opacity: 0;
  max-height: 0px;
}
</style>
<style lang="scss">
.vue-typer {
  /* Styles for the vue-typer container
     e.g. font-family, font-size  */
  letter-spacing: 1px;
  .custom.char {
    /* Styles for each character
       e.g. color, background-color */

    &.typed {
      /* Styles specific to typed characters
         i.e. characters to the left of the caret */
      color: #fff;
    }
    &.selected {
      /* Styles specific to selected characters
         i.e. characters to the right of the caret while VueTyper's
              'eraseStyle' is set to a selection-based style */
    }
    &.erased {
      /* Styles specific to erased characters
         i.e. characters to the right of the caret while VueTyper's
              'eraseStyle' is set to a non-selection-based style */
    }
  }
  .custom.caret {
    width: 10px;
    background-color: #fff;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Subscribe.vue